<template>
    <div class="container">
        <vue-element-loading :active="show" spinner="bar-fade-scale" background-color="rgba(18, 57, 112,0.3)"/>
        <div class="wrap">

            <progress-bar :list="list" :step="step" :step_="step_"></progress-bar>
            <div class="content">
                <div class="content-box">
                    <div class="content-box-menu">
                        <selection-menu :list="list" :step="step" :step_="step_"></selection-menu>
                    </div>
                    <transition-group name="list-complete" tag="div" class="content-box-list" :class="{_finish_:$store.state.selectData.finish}">
                        <div class="item list-complete-item" :class="{active:options!=item.id}" v-for="(item,index) in productList.items" :key="`source_${index}`" @click="selectDataEvent(item.id)" :style="{transitionDelay:`${index*0.1}s`}">
                            <div class="img">
                                <img :src="`/commons/image/cache?url=${encodeURIComponent(item.image)}`"
                                     alt="">
                                <div class="search">
<!--                                    <span @click.stop.prevent="findSame(item.image,1)">-->
<!--                                        淘宝-->
<!--                                    </span>-->
<!--                                    <span @click.stop.prevent="findSame(item.image,2)">-->
<!--                                        1688-->
<!--                                    </span>-->
                                    <span @click.stop.prevent="findSame(item.image,3)">
                                        百度
                                    </span>
<!--                                    <span @click.stop.prevent="findSame(item.image,4)">-->
<!--                                        京东-->
<!--                                    </span>-->
                                </div>
                            </div>
                            <div class="info">
                                <div class="title" :title="item.title">
                                    {{item.title}}
                                </div>
                                <div class="price-evaluate">
                                    <span>USD {{item.priceMin}}</span>
                                    <span>
                                        <rate-comp :value='item.reviewPercent' size="14" color='#FF971B' fullColor='#FF971B'
                                                   borderColor="#FF971B" margin="0 1px">
                                        </rate-comp>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </transition-group>
                    <div class="next">
                        <div class="next-btn" @click="$router.push('/experiment_0_5')">
                            上一步
                        </div>
                        <div class="next-btn" @click="$router.push('/experiment_1_1')">
                            下一步
                        </div>
                    </div>
                    <div class="foot" v-if="productList.pagination">
                        <pagination :total="productList.pagination.total"
                                    :page-size="productList.pagination.pageSize"
                                    :page-no="productList.pagination.pageNo"
                                    :count="5"
                                    @changePageNo="changePageNo"></pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import RateComp from '@/components/common/rate.vue'
    import Pagination from "../components/common/Pagination"
    import ProgressBar from "../components/common/ProgressBar"
    import SelectionMenu from "../components/common/SelectionMenu"

    export default {
        name: "experiment_1_0",
        components: {
            RateComp,
            Pagination,
            ProgressBar,
            SelectionMenu
        },
        data() {
            return {
                productData:{
                    category:this.$store.state.selectData.category,
                    material:this.$store.state.selectData.material,
                    keyword:this.$store.state.selectData.keyword,
                    minPrice:this.$store.state.selectData.prices.minPrice,
                    maxPrice:this.$store.state.selectData.prices.maxPrice,
                    reviewRate:this.$store.state.selectData.reviewRate,
                    blackList:this.$store.state.selectData.blackList,
                    pagination:{
                        pageNo:1,
                        pageSize:10
                    }
                },
                productList:{},
                show:false,
                laravelData:[{}],
                getResults:1
            }
        },
        computed:{
            step:function(){
                let $arr = /experiment_([0-9]+)_([0-9]+)/.exec(this.$route.path);
                return $arr[1]
            },
            step_:function(){
                let $arr = /experiment_([0-9]+)_([0-9]+)/.exec(this.$route.path);
                return $arr[2];
            },
            options: function () {
                return this.$store.state.selectData.selectProductId
            },
            allOptions:function(){
                return this.$store.state.selectData
            },
            list:function () {
                return this.$store.state.currentExperiment
            }
        },
        created() {
            this.show = true;
            this.$axios.post('/student/select/product/list', this.productData).then(res => {
                this.productList = res;
                this.show = false
            })
        },
        methods: {
            selectDataEvent(value){
                this.$store.dispatch('submitRecode',{label:'selectProductId',value:value})
                this.$store.dispatch('submitRecode',{label:'dataContrastId',value:''})
            },
            findSame(imgurl,type){
                this.show = true;
                this.$axios.post("/student/select/product/same", {'url': imgurl, 'type': type}).then((res) => {
                    if (res.succeed) {
                        this.show = false;
                        this.$openNewWindow(res.redirect,Date.parse(new Date))
                    } else {
                        this.$message.error(res.message);
                    }
                })
            },
            remote(){
                this.show = true;
                this.$axios.post('/student/select/product/list', this.productData).then(res => {
                    this.productList = res;
                    this.show = false
                })
            },
            changePageNo(item){
                this.productData.pagination.pageNo = item;
                this.productList = [];
                this.remote()
            },
        }
    }
</script>

<style scoped lang="scss">
    $rem: 0.01rem;
    .list-complete-item {
        transition: all 1s;
        display: inline-block;
        margin-right: 10px;
    }

    .list-complete-enter, .list-complete-leave-to
        /* .list-complete-leave-active for below version 2.1.8 */
    {
        opacity: 0;
        transform: translateX(-30px);
    }

    .list-complete-leave-active {
        position: absolute;
    }
    div.container {
        width: 100%;
        padding-top: 10px;
        display: flex;
        justify-content: center;

        div.wrap {
        padding-top: 10*$rem;
            width: 1622*$rem;
            color: #ffffff;

            div.title > h1 {
                font-size: 44*$rem;
                font-weight: bolder;
            }


            div.content {
                width: 1622*$rem;
                height: 775*$rem;
                box-sizing: border-box;
                background: url("./../assets/images/experiment_bg.png");
                background-size: cover;
                padding-top: 84*$rem;
                display: flex;
                align-items: center;
                flex-direction: column;

                div.content-box {
                    background: #344D76;width: 1496*$rem;
                    height: 532*$rem;
                    border: 2*$rem solid #25FCFF;
                    box-sizing: border-box;
                    position: relative;

                    div.content-box-menu {
                        display: flex;
                        position: absolute;
                        top: -20*$rem;
                        left: 88*$rem;z-index:10;
                        z-index: 10;

                    }

                    div.content-box-list {
                        display: flex;
                        flex-wrap: wrap;
                        padding: 38*$rem 0 0 86*$rem;
                        div.item {
                            width: 240*$rem;
                            height: 224*$rem;
                            background: #ffffff;
                            display: flex;
                            /*border: 4px solid transparent;*/
                            flex-direction: column;
                            margin-right: 18*$rem;
                            margin-bottom: 18*$rem;
                            position: relative;
                            cursor: pointer;
                            &.active:before {
                                content: '';
                                position: absolute;
                                top: 0;
                                left: 0;
                                width: 100%;
                                height: 100%;
                                background: rgba(0, 0, 0, 0.3);
                                box-shadow: 0 0 240*$rem rgba(0,0,0,0.6) inset;
                                z-index: 1;
                            }
                            > .img {
                                width: 100%;
                                height: 136*$rem;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                > img {
                                    width: auto;
                                    max-width: 100%;
                                    height: 100%;
                                }
                                position: relative;
                                &:hover > div.search {
                                    visibility:inherit;
                                }
                                > div.search {
                                    width: 100%;
                                    height: 32*$rem;
                                    background: rgba(255, 135, 0, 0.9);
                                    color: #ffffff;
                                    position: absolute;
                                    top: 108*$rem;
                                    left: 0;
                                    display: flex;
                                    align-items: center;
                                    justify-content: space-around;
                                    visibility:hidden;
                                    cursor: pointer;
                                    > span {
                                        font-size: 12*$rem;
                                        color: #FFDBB1;
                                        font-weight: bold;
                                        &:hover {
                                            color: #FFFFFF;
                                            cursor: pointer;
                                        }
                                    }
                                }
                            }
                            > div.info {
                                display: flex;
                                flex-direction: column;
                                justify-content: space-around;
                                align-items: center;
                                padding: 8*$rem 12*$rem;
                                height: 72*$rem;
                                overflow: hidden;
                                > .title {
                                    font-size: 14*$rem;
                                    color: #2c3e50;
                                    font-weight: bold;
                                    line-height: 16*$rem;
                                    text-overflow: ellipsis;
                                    display: -webkit-box;
                                    -webkit-box-orient: vertical;
                                    -webkit-line-clamp: 2;
                                    overflow: hidden;
                                    box-sizing: border-box;
                                }
                                > .price-evaluate {
                                    width: 100%;
                                    font-size: 16*$rem;
                                    color: #FF8700;
                                    font-weight: bold;
                                    display: flex;
                                    justify-content: space-between;
                                    align-items: center;
                                    margin-top: 6*$rem;

                                    span {
                                        font-size: 16*$rem;
                                        font-weight: bold;
                                    }
                                }
                            }
                        }

                    }

                    div.next {
                        position: absolute;
                        bottom: 0;
                        right: 0;
                        display:flex;transform: translate(0*$rem, calc(100% + 0.2rem));

                        > div.next-btn {
                            cursor: pointer;
                            font-size: 16*$rem;
                            text-align: center;
                            line-height: 44*$rem;
                            width: 164*$rem;
                            height: 44*$rem;
                            margin-left:20*$rem;background: url("./../assets/images/next_button_bg.png");
                            background-size: cover;
                            font-family: "SimHei", serif;
                            font-weight: bold;
                        }
                    }
                    .foot {
                        position: absolute;
                        left: 0;
                        bottom: 0;
                        transform: translate(0,calc(100% + 0.2rem));
                    }
                }
            }
        }
    }
</style>
